import React from "react";
import Paragraph from "../atoms/Paragraph";
import styled from "styled-components";
import { withModal } from "../../contexts/ModalContext";
import { withRouter } from "react-router";
import Resume from "../atoms/icons/Resume";
import { useTranslation } from "react-i18next";
import { color } from "../invoned/templates/ui";
const StyledParagraph = styled(Paragraph) `
  text-align: center;
  color: ${color.tertiary.base};
  font-size: 14px;
  line-height: 1.6;
`;
const Title = styled.h3 `
  margin-bottom: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: ${color.tertiary.base};
`;
const IconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
`;
const PendingStatus = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: #ee8e1a;
`;
const ResumeIcon = styled(Resume) `
  width: 45px;
  height: 40px;
`;
const Form = styled.div `
  position: relative;
`;
const CheckIcon = () => (React.createElement("svg", { width: "75", height: "75", viewBox: "0 0 77 77", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { width: "76.875", height: "76.875", rx: "38.4375", fill: "#6EBE44" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.557 24.2866C54.0246 23.7501 53.3026 23.4487 52.5497 23.4487C51.7969 23.4487 51.0748 23.7501 50.5425 24.2866L30.7105 44.2738L24.4575 37.9725C23.9213 37.4565 23.206 37.1723 22.4646 37.1808C21.7232 37.1893 21.0146 37.4898 20.4902 38.018C19.9658 38.5462 19.6672 39.2602 19.6584 40.0073C19.6496 40.7544 19.9312 41.4753 20.443 42.0159L28.7022 50.3389C28.9653 50.6059 29.2782 50.8177 29.6228 50.9623C29.9675 51.1068 30.3371 51.1812 30.7105 51.1812C31.0838 51.1812 31.4535 51.1068 31.7981 50.9623C32.1428 50.8177 32.4557 50.6059 32.7188 50.3389L54.557 28.3321C55.667 27.2156 55.667 25.4051 54.557 24.2866Z", fill: "#EBEFF2" })));
const PaymentArrangementStatusModal = ({ isAccepted, isPending, request, }) => {
    const { t } = useTranslation(["common", "dossier"]);
    return (React.createElement(Form, null,
        React.createElement(IconWrapper, null, isAccepted ? (React.createElement(CheckIcon, null)) : (React.createElement(PendingStatus, null,
            React.createElement(ResumeIcon, null)))),
        isAccepted && React.createElement(Title, null, t("dossier:arrangement.auto_approved")),
        isPending && React.createElement(Title, null, t("dossier:arrangement.manual_approval")),
        isAccepted && (React.createElement(StyledParagraph, null, t("dossier:arrangement.auto_approved_description", {
            date: request.fullDate,
        }))),
        isPending && (React.createElement(StyledParagraph, null, t("dossier:arrangement.manual_approval_description")))));
};
export default withRouter(withModal(PaymentArrangementStatusModal));
